import { Suspense, lazy, useEffect, useState } from "react";
import useAxios from "src/hooks/useAxios";
import { cn } from "src/lib/utils";
import { LawyersSection, MainBanner } from "./components/Sections";
import { BottomRightLink } from "src/components/BottomRightLink";
import { MapSection } from "./components/Sections/MapSection";
import { StatsSection } from "./components/Sections/StatsSection";
import { CompanySection } from "./components/Sections/CompanySection";
import { InsightSection } from "./components/Sections/InsightSection";
import { ReviewSection } from "./components/Sections/ReviewSection";
import { ReasonSection } from "./components/Sections/ReasonSection";
import { TutorialSection } from "./components/Sections/TutorialSection";
import { Footer } from "src/v1/ui/footer/Footer";
import { getGoogleAdUtm } from "src/v1/features/LeadForm/helpers/googleAd";
import { isHydratingFromPrerender, isPrerender } from "src/common/prerender";

// 상담 신청 폼은 구글 광고·AI 툴(utm_medium=ai) 방문자만 쓰므로, 그때만 따로 불러온다 (다른 방문자의 첫 로딩이 가벼워진다)
const LeadFormSection = lazy(() => import("src/v1/features/LeadForm/components/LeadFormSection"));

export default function LandingPage() {
  const { axiosGetNoAuth } = useAxios();
  // null = skeleton: the build-time prerender keeps it (the live count is never baked into the HTML), and
  // hydrating that HTML starts from the same skeleton until the count arrives
  const [suimCount, setSuimCount] = useState<number | null>(
    isPrerender() || isHydratingFromPrerender() ? null : 61613,
  );
  // 구글 광고·AI 툴로 들어온 방문자에게만 상담 신청 폼을 보여준다
  const isGoogleAdVisitor = getGoogleAdUtm() !== null;

  useEffect(() => {
    if (isPrerender()) return;
    const fetchCount = async () => {
      const data = await axiosGetNoAuth("/api/landings/cm/count");
      setSuimCount(data ?? 61613);
    };
    fetchCount();
  }, []);

  return (
    // 하단 고정 바 높이(--lead-bar-h)를 여기서 한 번만 정한다: 모바일 84px, 태블릿부터는 바가 없어서 0.
    // 바가 맨 아래 내용(푸터)을 가리지 않도록 같은 만큼 여백을 둔다.
    <main
      className={cn(
        isGoogleAdVisitor &&
          "[--lead-bar-h:84px] tablet:[--lead-bar-h:0px] pb-[var(--lead-bar-h)]",
      )}
    >
      <div className="">
        <MainBanner suimCount={suimCount} hasBottomBar={isGoogleAdVisitor} />
        <LawyersSection />
        <MapSection />
        <StatsSection suimCount={suimCount} />
        <CompanySection />
        {isGoogleAdVisitor && (
          <Suspense fallback={null}>
            <LeadFormSection />
          </Suspense>
        )}
        <InsightSection />
        <ReviewSection />
        <ReasonSection />
        <TutorialSection />
        <Footer />
      </div>
      {/* 하단 바에 카톡상담이 있으니, 바가 보이는 모바일에선 떠 있는 카톡 버튼을 숨긴다 */}
      <div className={cn(isGoogleAdVisitor && "hidden tablet:block")}>
        <BottomRightLink />
      </div>
    </main>
  );
}
